import Vue from 'vue';
import Notifications from 'vue-notification';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import VueMaterial from 'vue-material';
import VuejsDialog from 'vuejs-dialog'; //https://github.com/godofbrowser/vuejs-dialog
import { Mixin } from 'gw-js-lib';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import i18n from './i18n';
import App from './App.vue';
import router from './router';
import store from './store';

import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vuejs-dialog/dist/vuejs-dialog.min.css';

import firebase from "firebase/app";
import "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCX0vWzO-9J8yjTxHcQ_kLLZCrCdLJef6s",
    authDomain: "groundworx-2020.firebaseapp.com",
    databaseURL: "https://groundworx-2020.firebaseio.com",
    projectId: "groundworx-2020",
    storageBucket: "groundworx-2020.appspot.com",
    messagingSenderId: "856862934612",
    appId: "1:856862934612:web:c2a3fba51dd45eef7f0fc1",
    measurementId: "G-PCLRT9F3M7"
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();
Vue.prototype.$analytics = firebase.analytics();

const url = new URL(window.location.href);
const stayDesktopVersion = url.searchParams.get('stay-desktop-version')
  ? url.searchParams.get('stay-desktop-version') : localStorage.getItem('stayDesktopVersion');

// eslint-disable-next-line
function G_isMobile() {
  let isMobile = false;
  // eslint-disable-next-line
  (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) isMobile = true; })(navigator.userAgent || navigator.vendor || window.opera);
  return isMobile;
}

if (G_isMobile() && stayDesktopVersion !== 'true') {
  window.location.href = process.env.VUE_APP_LINK_MOBILE_VERSION;
} else {
  localStorage.setItem('stayDesktopVersion', stayDesktopVersion);

  let defaultLanguage = process.env.VUE_APP_LOCALE;
  if (store.state && store.state.user && store.state.user.language) {
    defaultLanguage = store.state.user.language;
    i18n.locale = defaultLanguage;
  }

  Vue.config.productionTip = false;
  Vue.use(BootstrapVue);
  Vue.use(IconsPlugin);
  Vue.use(Notifications);
  Vue.use(VueMaterial);
  Vue.use(VuejsDialog);


  Vue.mixin(Mixin);
  Mixin.methods.G_init({
    store: (field) => {
      return store.state[field];
    },
    language: defaultLanguage,
    translate: (key) => {
      return i18n.t(key);
    }
  });

  if (process.env.VUE_APP_SENTRY_ENABLE === 'true') {
    Sentry.init({
      dsn: process.env.VUE_APP_SENTRY_END_POINT,
      environment: process.env.VUE_APP_SENTRY_ENV,
      integrations: [new Integrations.Vue({ Vue, attachProps: true })],
    });
  }

  const VUE_APP = new Vue({
    i18n,
    router,
    store,
    render: (h) => h(App),
  });
  VUE_APP.$mount('#app');
  Mixin.data().consts.Context.APP = VUE_APP;
}
